export default __webpack_public_path__ + "static/media/webcam13.d8cc9a3e.jfif";